import {Component} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap';
import {AngularFireDatabase} from 'angularfire2/database';
import {Schedule, ScheduleDay, ScheduleHour} from '../../models/Schedule';
import {TranslateService} from '@ngx-translate/core';
import {TimeTrackerService} from '../time-tracker-service.service';
import {User} from '../../models/User';
import {ScheduleService} from '../services/ScheduleService';

@Component({
        selector: 'app-schedule-modal',
        template: `
            <div class="modal-header">
                <h4 class="modal-title pull-left">
                    {{'SCHEDULE' | translate}}
                </h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="container-form">

                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-description class="small">
                                    <div [innerHTML]="scheduleService.generateVerboseSchedule(schedule.schedule)"></div>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <table class="table fullWith">
                                <ng-container *ngFor="let scheduleDay of schedule.schedule">
                                    <tr>
                                        <td class="align-middle">{{scheduleDay.day | translate}}</td>
                                        <td>
                                            <mat-chip-list>
                                                <ng-container *ngFor="let hour of scheduleDay.hours">
                                                    <ng-template #popTemplate>
                                                        <table class="table table-sm">
                                                            <tr>
                                                                <th class="text-center">IN</th>
                                                                <th class="text-center">OUT</th>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <mat-form-field class="maxW100">
                                                                        <input matInput type="time" class="small"
                                                                               [(ngModel)]="hour.in"/>
                                                                    </mat-form-field>
                                                                </td>
                                                                <td>
                                                                    <mat-form-field class="maxW100">
                                                                        <input matInput type="time" class="small"
                                                                               [min]="hour.inModel"
                                                                               [(ngModel)]="hour.out"/>
                                                                    </mat-form-field>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </ng-template>
                                                    <mat-chip [popover]="popTemplate" popoverTitle="Select hour"
                                                              [selectable]="true"
                                                              (remove)="scheduleDay.hours.splice(scheduleDay.hours.indexOf(hour),1)"
                                                              outsideClick="true">
                                                        {{ hour.in + '-' + hour.out }}
                                                        <mat-icon matChipRemove>cancel</mat-icon>
                                                    </mat-chip>
                                                </ng-container>
                                            </mat-chip-list>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0)" (click)="addScheduleHour(scheduleDay)">
                                                <i class="mdi mdi-plus"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </ng-container>
                            </table>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
            <div class="modal-footer">
                <button *ngIf="!editMode" mat-raised-button color="accent" type="button" (click)="save()">
                    {{'SAVE' | translate}}
                </button>
                <button *ngIf="editMode" mat-raised-button color="accent" type="button" (click)="update()">
                    {{'UPDATE' | translate}}
                </button>
            </div>
        `,
        providers: [BsModalService]
    }
)

export class ScheduleModalComponent {

    public schedule: Schedule;
    public user: User;
    public editMode: boolean;

    constructor(public bsModalRef: BsModalRef, public ts: TranslateService, public scheduleService: ScheduleService,
                public tts: TimeTrackerService, public af: AngularFireDatabase) {
        this.generateSchedule();
        this.editMode = false;
    }

    public generateSchedule() {
        this.schedule = Schedule.defaultSchedule();
    }

    public addScheduleHour(scheduleDay: ScheduleDay) {
        let scheduleHours = scheduleDay.hours;
        if (scheduleHours && scheduleHours.length > 0) {
            const lastOut: string = scheduleHours[scheduleHours.length - 1].out;
            scheduleHours.push(new ScheduleHour(
                this.millisToTimeString(
                    this.scheduleService.stringHourToMillis(lastOut) + this.scheduleService.stringHourToMillis('00:30')),
                this.millisToTimeString(
                    this.scheduleService.stringHourToMillis(lastOut) + +this.scheduleService.stringHourToMillis('04:30'))
            ));
        } else {
            scheduleDay.hours = [new ScheduleHour('8:30', '12:30')];
        }
    }

    public millisToTimeString(millis: number): string {
        return ('0' + Math.floor(millis / 1000 / 60 / 60) % 24).slice(-2) + ':' + ('0' + Math.floor(millis / 1000 / 60) % 60).slice(-2);
    }

    public save() {
        this.schedule.userId = this.user.id;
        this.tts.createSchedule(this.schedule, () => {
            this.bsModalRef.hide();
        });
    }

    public update() {
        this.schedule.userId = this.user.id;
        this.af.object(TimeTrackerService.SCHEDULES + '/' + this.schedule.id)
            .set(this.schedule)
            .then(() => {
                this.bsModalRef.hide();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modals/schedule-modal.ts